import { useSearchParams } from 'react-router-dom';

/** Marketplace / CI screenshot ingress — hides lab chrome and expands the canvas. */
export function useLabCaptureMode(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.get('capture') === '1';
}
